import { Link } from 'react-router-dom';
import { Instagram, Linkedin } from 'lucide-react';

const COLS = [
  ['For Students', [['Join the Talent Network', '/network'], ['Career Readiness Check', '/career-readiness-check'], ['Career Clarity Consultation', '/apply?plan=clarity-session'], ['Learning Paths', '/learning-paths'], ['Programs & Pricing', '/programs'], ['My Career Journey', '/my-journey']]],
  ['For Partners', [['For Colleges', '/for-colleges'], ['For Employers', '/for-employers'], ['Careers at Elevate', '/careers']]],
  ['Company', [['About', '/about'], ['FAQ', '/faq'], ['Contact', '/contact']]],
];

export const Footer = () => (
  <footer className="bg-[#081738] text-slate-300" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-[1.3fr_1fr_1fr_1fr]">
      <div>
        <Link to="/" className="inline-block bg-white rounded-xl px-3 py-1.5"><img src="/logo-elevate-careers.webp" alt="Elevate Careers" className="h-8 w-auto" /></Link>
        <p className="text-sm text-slate-400 mt-5 max-w-xs leading-relaxed">Career clarity, practical skills and real opportunities for India's students and early-career professionals.</p>
        <div className="flex items-center gap-4 mt-5">
          <a href="https://www.linkedin.com/company/elevate-careers-india" target="_blank" rel="noopener noreferrer" className="inline-flex text-slate-400 hover:text-teal-300" aria-label="LinkedIn" data-testid="footer-linkedin"><Linkedin className="w-5 h-5" /></a>
          <a href="https://www.instagram.com/elevatecareersindia.in/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-teal-300" aria-label="Instagram @elevatecareersindia.in" data-testid="footer-instagram"><Instagram className="w-5 h-5" />@elevatecareersindia.in</a>
        </div>
      </div>
      {COLS.map(([title, links]) => (
        <div key={title}>
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-teal-300 mb-4">{title}</p>
          <ul className="space-y-2.5 text-sm">{links.map(([t, to]) => <li key={t}><Link to={to} className="hover:text-white transition-colors">{t}</Link></li>)}</ul>
        </div>
      ))}
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-wrap gap-x-6 gap-y-2 text-xs text-slate-500">
        <span>© {new Date().getFullYear()} Elevate Careers</span>
        <Link to="/privacy" className="hover:text-slate-300">Privacy</Link>
        <Link to="/terms" className="hover:text-slate-300">Terms</Link>
        <Link to="/disclaimer" className="hover:text-slate-300">Disclaimer</Link>
        <a href="mailto:team@elevatecareersindia.in" className="hover:text-slate-300">team@elevatecareersindia.in</a>
        <a href="https://wa.me/919311510040?text=Hi%20Elevate%20Careers" target="_blank" rel="noopener noreferrer" className="hover:text-slate-300">WhatsApp</a>
        <span className="ml-auto">No placement guarantees.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
